module.exports = __webpack_public_path__ + "img/3.d82cd3cd.png";